// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Trentatre() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/33Magazine/33Magazine_5.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/33Magazine/33Magazine_1.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/33Magazine/33Magazine_2.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/33Magazine/33Magazine_3.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/33Magazine/33Magazine_4.jpg',
        },
        {
            id: 6,
            imgSrc: '/images/33Magazine/Cover33.jpg',
        },
        {
            id: 7,
            imgSrc: '/images/33Magazine/33Magazine_6.jpg',
        },
        {
            id: 8,
            imgSrc: '/images/33Magazine/33Magazine_7.jpg',
        },
        {
            id: 9,
            imgSrc: '/images/33Magazine/33Magazine_8.jpg',
        },
        {
            id: 10,
            imgSrc: '/images/33Magazine/33Magazine_9.jpg',
        },
        
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="33 Magazine" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="33 Magazine" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Trentatre;
